import styled from 'styled-components';
import Image from 'next/image';

interface IProps {
  title: string;
  snippet: string;
  media: any;
  slug: string;
  imageAlt?: string;
}

const BlogHero = ({
  title,
  snippet,
  media,
  imageAlt,
  slug
}: IProps): JSX.Element => {
  const BlogHero = styled.div`
    position: relative;
    display: flex;
    height: 40vh;

    /* Apply 62vh on screens >= 640px */
    @media (min-width: 640px) {
      height: 62vh;
    }
    @media (min-width: 1024px) {
      height: 485px;
    }
    @media (min-width: 1280px) {
      height: 512px;
    }
    @media (min-width: 1536px) {
      height: 515px;
    }
    @media (min-width: 1600px) {
      height: 520px;
    }
    @media (min-width: 1800px) {
      height: 565px;
    }
  `;

  // Styled component for Image
  const StyledImage = styled(Image)`
    z-index: 0;
    height: 100%;
    width: 100%;
    object-fit: cover;
  `;

  return (
    <>
      {slug === 'see-sight-tours-becomes-tripshepherd' ? (
        <section className="Hero_Section">
          <BlogHero className="BlogHero gap-5 px-[15%] bg-black bg-no-repeat bg-cover bg-center flex  flex-col justify-center items-center h-full">
            <StyledImage
              alt="guidesImage"
              src="https://res.cloudinary.com/see-sight-tours/image/upload/v1704953373/pexels-pixabay-373543_scspzy.jpg"
              layout="fill"
            />
            <div
              className={`absolute top-0 w-full h-full bg-black  z-20 bg-opacity-90`}
            ></div>
            <div className="PageHero_container flex flex-col   justify-center  z-30 w-full  items-center my-[60px]">
              <h1 className="text-3xl md:text-4xl lg:text3xl 2xl:text-6xl text-white font-extrabold pb-4  ">
                See Sight Tours
              </h1>
              <h2 className="text-xl md:text-2xl lg:text-3xl 2xl:text-4xl text-white font-extrabold pb-4  ">
                The Evolution of See Sight Tours
              </h2>
              <div className="flex w-full justify-evenly pb-4 items-center">
                <Image
                  src="https://res.cloudinary.com/see-sight-tours/image/upload/v1598548912/see-sight-tours-logo-stacked.png"
                  width={200}
                  height={100}
                  alt="New logo for see sight tours now known as trip shepherd"
                  className="w-[35%] md:w-[150px] xl:w-[200px] "
                />
                <Image
                  src="https://res.cloudinary.com/see-sight-tours/image/upload/v1704261728/logos/TS-Logo_New_Stacked_o630sx.webp"
                  width={300}
                  height={110}
                  alt="New logo for see sight tours now known as trip shepherd"
                  className="w-[50%] md:w-[200px] xl:w-[300px] "
                />
              </div>
              <p className="text-sm md:text-base text-white">{title}</p>
            </div>
          </BlogHero>
        </section>
      ) : (
        <section className="Hero_Section ">
          <BlogHero className="BlogHero bg-no-repeat bg-cover bg-center flex justify-start items-center relative">
            <StyledImage
              alt={imageAlt ?? 'Featured Image'}
              src={media}
              layout="fill"
            />
            <div
              className={`absolute top-0 w-full h-full ${
                slug !== 'see-sight-tours-becomes-tripshepherd' && 'bg-black'
              } z-20 bg-opacity-40`}
            ></div>
            <div className="PageHero_container absolute left-[15px] bottom-[30px] z-30">
              <h1 className="text-white text-base md:text-2xl lg:text-2xl 2xl:text-3xl font-normal uppercase tracking-wide w-[245px] msm:w-[350px] xl:w-[677px] md:w-[600px] lg:w-[540px]">
                {title}
              </h1>
            </div>
          </BlogHero>
        </section>
      )}
    </>
  );
};

export default BlogHero;
